import React from 'react'

import styles from './Gateway.module.scss'
import images from 'assets/images'
import useResizeWidth from 'controller/useResizeWidth'
import Faq from 'components/Faq'
import { getLength } from 'commons/function'

const arrProjects = {
  wallet: [
    {
      icon: images.ecoWallet1,
      name: 'Coin98 Super Wallet',
      link: 'https://coin98.com/',
      value: 'wallet',
      isNative: true,
    },
    {
      icon: images.ecoWallet2,
      name: 'Viction Wallet',
      link: 'https://viction.xyz/wallet',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet3,
      name: 'Ramper',
      link: 'https://www.ramper.xyz/',
      value: 'wallet',
      isNative: true,
    },
    {
      icon: images.ecoWallet4,
      name: 'MetaMask',
      link: 'https://metamask.io/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet5,
      name: 'Cobo',
      link: 'https://www.cobo.com',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet6,
      name: 'Trezor',
      link: 'https://trezor.io/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet7,
      name: 'Privy',
      link: 'https://www.privy.io',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet8,
      name: 'iMe',
      link: 'https://www.imem.app/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet9,
      name: 'Reown',
      link: 'https://reown.com/blog/how-to-get-started-with-reown-appkit-on-viction',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet10,
      name: 'imToken',
      link: 'https://token.im/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet11,
      name: 'Fox Wallet',
      link: 'https://foxwallet.com/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet12,
      name: 'SubWallet',
      link: 'https://www.subwallet.app/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet13,
      name: 'Frontier',
      link: 'https://www.frontier.xyz/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet14,
      name: 'Nabox',
      link: 'https://nabox.io/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet15,
      name: 'Hybrix',
      link: 'https://hybrix.io/en',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet16,
      name: 'Blazpay',
      link: 'https://blazpay.com/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet17,
      name: 'Fearless',
      link: 'https://fearlesswallet.io/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet18,
      name: 'Nuvo',
      link: 'https://www.nuvosphere.io/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet19,
      name: 'Krystal',
      link: 'https://krystal.app/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet20,
      name: 'Piena',
      link: 'https://www.plena.finance/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet21,
      name: 'Trust',
      link: 'https://trustwallet.com/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet22,
      name: 'Holdstation',
      link: 'http://www.holdstation.com/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet23,
      name: 'Math Wallet',
      link: 'https://mathwallet.org/en-us/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet24,
      name: 'Desig',
      link: 'https://desig.io/',
      value: 'wallet',
    },
    // {
    //   icon: images.ecoWallet25,
    //   name: 'SendToken',
    //   link: '',
    //   value: 'wallet',
    // },
    {
      icon: images.ecoWallet26,
      name: 'MyCrypto',
      link: 'https://mycrypto.com/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet27,
      name: 'MEW',
      link: 'https://www.myetherwallet.com',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet28,
      name: 'BlockWallet',
      link: 'https://blockwallet.io/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet29,
      name: 'NOW Wallet',
      link: 'https://walletnow.app/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet30,
      name: 'Wigwam',
      link: 'https://wigwam.app/',
      value: 'wallet',
    },
    // {
    //   icon: images.ecoWallet31,
    //   name: 'INTOverse',
    //   link: '',
    //   value: 'wallet',
    // },
    {
      icon: images.ecoWallet32,
      name: 'Token Pocket',
      link: 'https://www.tokenpocket.pro/',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet33,
      name: 'Zen Card',
      link: 'https://www.zencard.co',
      value: 'wallet',
    },
    {
      icon: images.ecoWallet34,
      name: 'Enkrypt',
      link: 'https://www.enkrypt.com/',
      value: 'wallet',
    },
  ],
  exchange: [
    // {
    //   icon: images.ecoExchange1,
    //   name: 'Binance',
    //   link: 'https://www.binance.com/en/trade/VIC_USDT',
    //   value: 'exchange',
    // },
    {
      icon: images.ecoExchange2,
      name: 'Bybit',
      link: 'https://www.bybit.com/trade/spot/VIC/USDT/',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange3,
      name: 'Gate',
      link: 'https://gate.io/trade/VIC_USDT',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange4,
      name: 'MEXC',
      link: 'https://www.mexc.com/exchange/VIC_USDT',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange5,
      name: 'Aliniex',
      link: 'https://aliniex.com/mua-ban/vic',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange17,
      name: 'Bitkub',
      link: 'https://www.bitkub.com/en/market/vic',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange7,
      name: 'BTSE',
      link: 'https://www.btse.com/en/trading/VIC-USDT',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange11,
      name: 'Coins.ph',
      link: 'https://www.coins.ph/en-ph/trade/VIC/PHP',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange9,
      name: 'Bitget',
      link: 'https://www.bitget.com/spot/VICUSDT?channelCode=42xn&vipCode=sq59&languageType=0',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange10,
      name: 'StealthEX',
      link: 'https://stealthex.io/exchange/new/',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange8,
      name: 'Biconomy',
      link: 'https://www.biconomy.com/exchange/VIC_USDT',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange12,
      name: 'BitMart',
      link: 'https://www.bitmart.com/trade/en?symbol=$VIC_USDT&r=PjkAFy',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange13,
      name: 'LBank',
      link: 'https://www.lbank.com/trade/viction_usdt',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange14,
      name: 'BingX',
      link: 'https://bingx.com/en-us/spot/VICUSDT?ch=cgk_organic',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange15,
      name: 'Giottus',
      link: 'https://www.giottus.com/',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange16,
      name: 'HTX',
      link: 'https://www.huobi.com/en-us/exchange/vic_usdt',
      value: 'exchange',
    },
    {
      icon: images.ecoExchange6,
      name: 'AscendEX',
      link: 'https://ascendex.com/en/cashtrade-spottrading/usdt/vic?inviteCode=ASDH38HE',
      value: 'exchange',
    },
  ],
}

const arrFaq = [
  {
    id: 'faq1',
    question: 'How to add Viction (VRC25) to Metamask wallet?',
    answer:
      'To add Viction (VRC25) to MetaMask, follow these steps in <span><a href="https://docs.viction.xyz/how-to/how-to-connect-to-viction-network/metamask" target="_blank" rel="nofollow noreferrer">this guideline.</a></span>',
  },
  {
    id: 'faq2',
    question: 'Are crypto wallets free?',
    answer:
      'Most hot wallets are typically free to download and use, except for cold wallets which require apurchase. Some wallets may charge additional transaction fees.',
  },
  {
    id: 'faq3',
    question: 'What is the best VIC wallet for beginners?',
    answer: `The best wallet depends on individual needs, but beginners often prefer hot wallets for easy access and social wallets for seamless onboarding.`,
  },
]

function GatewayScreen() {
  const projectContentRef = React.useRef(null)
  const { isScrollDown, positionY } = useResizeWidth()
  const [activeTab, setActiveTab] = React.useState('wallet')
  const [isShowMore, setIsShowMore] = React.useState(false)

  const isChangeProjectTab = positionY >= projectContentRef?.current?.offsetTop
  const projectShow =
    getLength(arrProjects[activeTab]) >= 20 && !isShowMore
      ? arrProjects[activeTab].slice(0, 20)
      : arrProjects[activeTab]

  const handleTabClick = (tab) => () => {
    setActiveTab(tab)
  }

  return (
    <div className={styles.gatewayScreen}>
      <div className='gateway-container'>
        <div className='gateway-banner'>
          <div className='banner-content'>
            <h1 className='gateway-title'>VIC Gateways</h1>

            <div className='gateway-description'>
              Discover top secure wallets, your gateway to manage tokens and
              easily access Viction ecosystem
            </div>
          </div>

          <img src={images.curveWhiteUp} alt='' className='curve-white-up' />
        </div>

        <div className='gateway-content'>
          <div className='gateway-heading' ref={projectContentRef}>
            <div
              className={`gateway-tab ${
                isChangeProjectTab && 'gateway-tab--change-style'
              } ${isScrollDown && 'gateway-tab--top-0'}`}>
              <div
                className={`tab-item ${
                  activeTab === 'wallet' && 'tab-item--active'
                }`}
                onClick={handleTabClick('wallet')}>
                Wallet
              </div>
              <div
                className={`tab-item ${
                  activeTab === 'exchange' && 'tab-item--active'
                }`}
                onClick={handleTabClick('exchange')}>
                Exchange
              </div>
            </div>

            <div className='gateway-tab-project'>
              {projectShow.map((item, index) => {
                const itemNative = item.isNative

                return (
                  <a
                    key={index}
                    href={item.link}
                    target='_blank'
                    rel='nofollow noreferrer'>
                    <div className='project-item'>
                      <div className='project-item__logo'>
                        <img src={item.icon} alt='' className='logo-project' />
                      </div>

                      <div className='project-item__info'>
                        <div className='info-name'>{item.name}</div>
                        <span className='icon-web_arrow_up_right arrow-hover'></span>
                      </div>

                      {itemNative && (
                        <div className='project-item__native'>Native</div>
                      )}
                    </div>
                  </a>
                )
              })}
            </div>

            {!isShowMore && (
              <div className='text-show'>
                {getLength(arrProjects[activeTab]) >= 20 && (
                  <div
                    className='text-show-more text-hover-underline'
                    onClick={() => setIsShowMore(!isShowMore)}>
                    Show More
                  </div>
                )}
              </div>
            )}
          </div>

          <div className='gateway-footer'>
            <div className='gateway-footer-content'>
              * Disclaimer: All tools interacting with assets are provided by
              partners of Viction and are not directly operated by us. Please
              always double-check the status of the tool and test with a small
              amount before performing large transactions to avoid potential
              loss.
            </div>
          </div>
        </div>

        <div className='gateway-faq'>
          <Faq arrFaq={arrFaq} />
        </div>
      </div>
    </div>
  )
}

export default GatewayScreen
